module.exports = __webpack_public_path__ + "1455f5ae7323f0473cad3d9c0ec4a059.svg";